import { localStore } from '@/services/local.storage';

export default function isVendor ({ next, store }){
    if(!store.getters.auth.loggedIn){
        return next({name:"Login"})
    }

    if(store.getters.auth.loggedIn && !store.getters.auth.isVendor){
        if(atob(localStore.getLocalStorage('role'))=='admin')
            return next({  name: 'Admin Dashboard'  });
        if(atob(localStore.getLocalStorage('role'))=='agent')
            return next({  name: 'Agent Dashboard'  });
    }
        return next()
}